// HomeWeb.jsx
import React , {useState, useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Alert, Linking , ActivityIndicator, Modal, Platform} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import axios from 'axios';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { useLogScreen } from '../useLogScreen';

export default function BoletoParceladoWeb() {
    useLogScreen('BoletoParcelado');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Parcelação de Boletos';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [usuario_id, setUsuario_id] = useState(false);

    const handleGerarCheckout = async () => {
        console.log("Entrou no handleGerarCheckout")
        if (isSubmitting) return;
        setIsSubmitting(true);
        setLoading(true);

        try {

            const response = await axios.get('https://api.imogo.com.br/api/v1/smart-pagamentos');

            const redirectUrl = response.data.response.redirectUrl;

            console.log("Redirect URL:", redirectUrl);
            navigation.navigate("webViewSmartPagamentosWeb", {
                usuario_id,
                url_assinar: redirectUrl
            });

        } catch (error) {
            console.error(error);
            Alert.alert('Erro', 'Não foi possível fazer o link de checkout.');
        } finally {
            setIsSubmitting(false); // Reativa o botão
            setLoading(false);
        }
    };
    console.log(usuario_id)
    return (
        <BaseWeb>
            {(userInfo) => {
                setUsuario_id(userInfo?.id);
                const email_solicitante = userInfo?.email;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Parcelamento de Boletos</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    Parcele o pagamento de qualquer boleto usando o limite do seu cartão de crédito! É rápido, seguro e você ainda acumula pontos nos programas da sua operadora de cartão de crédito!
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={handleGerarCheckout}>
                                        <Image
                                            source={require('../assets/icons/2perfil.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Comissão de corretagem</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={handleGerarCheckout}>
                                        <Image
                                            source={require('../assets/icons/avaliador-roxo.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Sinal</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={handleGerarCheckout}>
                                        <Image
                                            source={require('../assets/icons/home.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>IPTU/ITBI/ITCMD</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={handleGerarCheckout}>
                                        <Image
                                            source={require('../assets/icons/home.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Aluguel / Condomínio</Text>
                                            {/* Escrituras e Registro de imóvel */}
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={handleGerarCheckout}>
                                        <Image
                                            source={require('../assets/icons/files.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Outros</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <Modal transparent={true} animationType="fade" visible={loading}>
                            <View style={styles.loadingContainer}>
                                <ActivityIndicator size="large" color="white" />
                                <Text style={styles.loadingText}>Criando Link de Pagamento...</Text>
                            </View>
                        </Modal>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}